import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutUmrah.css';
import kaabaImage from '../assets/images/kaaba.webp';

const AboutUmrah = () => {
  useEffect(() => {
    document.title = "Lär dig om Umrah - Ritualer, Fördelar och Förberedelse";
    const metaDescription = document.createElement('meta');
    metaDescription.name = "description";
    metaDescription.content = "Utforska vad Umrah är, dess ritualer och de andliga fördelarna. Lär dig hur du förbereder dig för din resa till Mecka.";
    document.head.appendChild(metaDescription);

    return () => {
      document.head.removeChild(metaDescription);
    };
  }, []);

  return (
    <div className="about-container">
      <section className="content">
        <div className="content-wrapper">
          <h1 className="about-title">Information Om Umrah</h1>
          <img src={kaabaImage} alt="Kaaba i Mecka under Umrah" className="kaaba-image" />

          <h2>Vad är Umrah?</h2>
          <p>
            Umrah är en pilgrimsfärd till Mecka som kan utföras när som helst under året, till skillnad från Hajj som har
            specifika datum enligt den islamiska månkalendern. Umrah innebär att utföra vissa ritualer i den heliga staden Mecka,
            inklusive Tawaf (cirkulär rörelse runt Kaba) och Sa'i (vandring mellan bergen Safa och Marwa).
          </p>

          <h2><strong>Hur man utför Umrah – Steg för Steg</strong></h2>
          <ul>
            <li>
              <strong>1. Ihram:</strong> Gå in i ett tillstånd av andlig renhet. Män bär två vita tygstycken, kvinnor bär anständig klädsel. 
              Intentionen (niyyah) görs vid miqat, och man uttalar: <em>"Labbayka Allahumma Umrah"</em>.
            </li>
            <li>
              <strong>2. Tawaf:</strong> Gå sju varv moturs runt Kaba, med start vid den svarta stenen (Hajar al-Aswad). 
              Män bör, om möjligt, gå snabbt de tre första varven.
            </li>
            <li>
              <strong>3. Salah vid Maqam Ibrahim:</strong> Be två rakah bakom platsen där Ibrahims fotavtryck finns, om det är möjligt.
            </li>
            <li>
              <strong>4. Dricka Zamzam:</strong> Drick det välsignade Zamzam-vattnet efter Tawaf och be en personlig dua.
            </li>
            <li>
              <strong>5. Sa'i:</strong> Gå sju gånger mellan kullarna Safa och Marwa. Män springer lätt mellan de gröna lamporna.
            </li>
            <li>
              <strong>6. Rakning/Håruppklippning:</strong> Män rakar huvudet (eller klipper en del av håret), kvinnor klipper en liten del. 
              Detta markerar att Umrah är fullbordad.
            </li>
          </ul>

          <h2>Fördelar med att utföra Umrah</h2>
          <p>Att utföra Umrah har många andliga fördelar:</p>
          <ul>
            <li>Stärker ens tro och förbindelse med Allah.</li>
            <li>Möjlighet att söka förlåtelse för tidigare synder och börja på nytt.</li>
            <li>Uppleva enheten bland muslimer från hela världen.</li>
            <li>Få en djupare förståelse för islamisk historia och traditioner.</li>
          </ul>

          <h2>Förberedelser inför Umrah</h2>
          <p>Förberedelser är nyckeln till en meningsfull Umrah-upplevelse. Här är några tips:</p>
          <ul>
            <li>Lär dig ritualerna och betydelsen av Umrah.</li>
            <li>Se till att du har alla nödvändiga resehandlingar och vaccinationer.</li>
            <li>Packa lämpliga kläder och nödvändiga saker.</li>
            <li>Mental och andlig förberedelse genom bön och eftertanke.</li>
          </ul>

          <p>
            Redo att påbörja din andliga resa? Kolla in vårt <strong>Standard Paket</strong> eller <strong>Premium Paket</strong> för en oförglömlig upplevelse.
          </p>

          <div className="button-wrapper">
            <Link to="/umrah-package" className="action-button">
              Utforska Paket
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUmrah;
